import React from 'react';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { Typography, Box } from '@material-ui/core';
import { SafeSevenInput } from '../../../components/inputs/SafeSevenInput';
import { FORM_TYPES, getStepData } from '../../../enums/Steps';
import { useLanguage }  from "../../../hooks/useLanguage";

export const Safe7Intro = (props) => {
  const { t } = useLanguage();
  const handleSafeSevenSelect = () => {};

  const step = 'safe-intro';
  const { nextStep, prevStep, currentStepIndicator } = getStepData(step, FORM_TYPES.safe7);

  return (
    <React.Fragment>
      <ProgressBlock value1={100} value2={currentStepIndicator} />
      <div className="inner-form-container">
        <Box my={4}>
          <Typography variant={'h3'} align={'center'} className={'blue-font'}>
            <strong>{t('survey_info_title')}</strong>
          </Typography>
        </Box>
        <Typography variant={'h6'} className={'blue-font'}>
          {t('safe_info_text')}
        </Typography>
        <Box my={4}>
          <SafeSevenInput demo selected={8} handleSelect={handleSafeSevenSelect} />
        </Box>
      </div>
      <ActionBar prevState={prevStep} copy={''} nextState={nextStep} />
    </React.Fragment>
  );
};
